import React from 'react';

const XLogo = () => {
  return (
    <svg viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.0365 11L15.8278 18.1702L10 24H11.3117L16.4141 18.8958L20.5365 24H25L18.8827 16.4265L24.3073 11H22.9956L18.2967 15.7007L14.5 11H10.0365ZM11.9654 11.8946H14.0159L23.0708 23.1054H21.0203L11.9654 11.8946Z"
        fill="#353535"
      />
    </svg>
  );
};

export default XLogo;
